import React from 'react';

/**
 * Renders text with URLs automatically converted to clickable links.
 * URLs are detected and rendered as anchor tags with proper security attributes.
 */
export default function LinkifyText({ text, className = '', linkClassName = '' }) {
  if (!text) return null;
  
  // URL regex pattern - matches http, https, and www URLs
  const urlPattern = /(https?:\/\/[^\s<]+|www\.[^\s<]+)/gi;
  
  // Split text by URLs and create array of text/link segments
  const parts = text.split(urlPattern);
  
  // Find all URL matches
  const matches = text.match(urlPattern) || [];
  
  // If no URLs found, return plain text
  if (matches.length === 0) {
    return <span className={className}>{text}</span>;
  }
  
  // Build result with alternating text and links
  const result = [];
  let matchIndex = 0;
  
  parts.forEach((part, index) => {
    if (urlPattern.test(part)) {
      // This part is a URL
      const url = part.startsWith('http') ? part : `https://${part}`;
      result.push(
        <a
          key={`link-${index}`}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className={linkClassName || 'text-blue-500 hover:text-blue-700 underline break-all'}
          onClick={(e) => e.stopPropagation()} // Prevent card click when clicking link
          data-testid="linkified-url"
        >
          {part}
        </a>
      );
      matchIndex++;
    } else if (part) {
      // This part is regular text
      result.push(<span key={`text-${index}`}>{part}</span>);
    }
  });
  
  return <span className={className}>{result}</span>;
}
